import { COMPANY_TYPE, FIRM_TYPE, FUND_TYPE } from 'common/constants/pageTypes';

export const DESCRIPTION_TEXT = `Select what you would like to export, all selected data will
be exported in a single Excel Workbook. All data exported will be as of the currently selected
measurement date.`;
export const TITLE = 'Excel Export Ledger';
export const DOWNLOAD_LABEL = 'Download';
export const TABLE_HEADER_FIRST_TITLE_COMPANY = 'Export Company Data';
export const TABLE_HEADER_FIRST_TITLE_FIRM = 'Export Firm Data';
export const TABLE_HEADER_FIRST_TITLE_FUND = 'Export Fund Data';
export const TABLE_HEADER_FIRST_TITLE: { [key: string]: string } = {
  [COMPANY_TYPE]: TABLE_HEADER_FIRST_TITLE_COMPANY,
  [FIRM_TYPE]: TABLE_HEADER_FIRST_TITLE_FIRM,
  [FUND_TYPE]: TABLE_HEADER_FIRST_TITLE_FUND,
};

export const FORMULATED = 'formulated';
export const HARD_CODED = 'hardCoded';
export const PRINT_READY = 'printReady';
export const WORKBOOK_CONFIG = 'workbookConfig';

export const initialFormValues = {
  export_breakpoints: false,
  export_cap_table: false,
  export_documents: false,
  export_financials: false,
  export_firm_funds_summaries: false,
  export_firm_summary: false,
  export_fund_investments: false,
  export_fund_ownership: false,
  export_fund_summary: false,
  export_summary: false,
  export_valuations: false,
  export_waterfall: false,
  export_not_formulated: false,
  export_formulated_and_print_ready: false,
  include_documents_and_notes_from_tabs: true,
  breakpoint_cap_table: null,
  cap_table: null,
  financial_statement: null,
  fo_cap_table: null,
  valuation: null,
  waterfall_cap_table: null,
};
